import React from 'react';
import '../scss/main.scss'
import SectionHome from './SectionHome';
import SectionMain from './SectionMain';
import OtherLinks from './OtherLinks';
import SectionNft from './SectionNft';


export default function Home() {
  return (
    <div>

 <SectionHome/>
 <OtherLinks/>
 <SectionMain/>
 <SectionNft/>

    </div>
  )
}
